export enum FormWidgetType {
    AUTOCOMPLETE = 'autocomplete',
    CHECKBOX = 'checkbox',
    CHECKBOXSET = 'checkboxset',
    CHIPS = 'chips',
    COLORPICKER = 'colorpicker',
    CURRENCY = 'currency',
    CUSTOMWIDGET = 'custom-widget',
    DATE = 'date',
    DATETIME = 'datetime',
    ICONBUTTONTOGGLE = 'iconbutton-toggle',
    NUMBER = 'number',
    PASSWORD = 'password',
    RADIOSET = 'radioset',
    RATING = 'rating',
    RICHTEXT = 'richtext',
    SELECT = 'select',
    TOGGLE = 'toggle',
    SLIDER = 'slider',
    SWITCH = 'switch',
    TEXT = 'text',
    TEXTAREA = 'textarea',
    TIME = 'time',
    TIMESTAMP = 'timestamp',
    TYPEAHEAD = 'typeahead',
    UPLOAD = 'upload'
}

export const FormWidgetsListMap: {[key: string]: Array<FormWidgetType>} = {
  'wm-search': [FormWidgetType.AUTOCOMPLETE, FormWidgetType.TYPEAHEAD],
  'wm-checkboxset': [FormWidgetType.CHECKBOXSET],
  'wm-colorpicker': [FormWidgetType.COLORPICKER],
  'wm-date': [FormWidgetType.DATE],
  'wm-datetime': [FormWidgetType.DATETIME],
  'wm-time': [FormWidgetType.TIME],
  'wm-timestamp': [FormWidgetType.TIMESTAMP],
  'wm-textarea': [FormWidgetType.TEXTAREA],
  'wm-text': [FormWidgetType.TEXT],
  'wm-password': [FormWidgetType.PASSWORD],
  'wm-fileupload': [FormWidgetType.UPLOAD],
  'wm-slider': [FormWidgetType.SLIDER],
  'wm-switch': [FormWidgetType.SWITCH],
  'wm-toggle': [FormWidgetType.TOGGLE],
  'wm-iconbutton-toggle': [FormWidgetType.ICONBUTTONTOGGLE],
  'wm-radioset': [FormWidgetType.RADIOSET],
  'wm-checkbox': [FormWidgetType.CHECKBOX],
  'wm-select': [FormWidgetType.SELECT],
  'wm-chips': [FormWidgetType.CHIPS],
  'wm-rating': [FormWidgetType.RATING],
  'wm-currency': [FormWidgetType.CURRENCY],
  'wm-custom-widget': [FormWidgetType.CUSTOMWIDGET],
  'wm-number': [FormWidgetType.NUMBER],
  'wm-richtexteditor': [FormWidgetType.RICHTEXT]
};

export enum DataType {
    INTEGER = 'integer',
    BIG_INTEGER = 'big_integer',
    SHORT = 'short',
    FLOAT = 'float',
    BIG_DECIMAL = 'big_decimal',
    DOUBLE = 'double',
    LONG = 'long',
    BYTE = 'byte',
    STRING = 'string',
    CHARACTER = 'character',
    TEXT = 'text',
    DATE = 'date',
    TIME = 'time',
    TIMESTAMP = 'timestamp',
    DATETIME = 'datetime',
    LOCALDATETIME = 'localdatetime',
    BOOLEAN = 'boolean',
    LIST = 'list',
    CLOB = 'clob',
    BLOB = 'blob'
}

export enum MatchMode {
    BETWEEN = 'between',
    GREATER = 'greaterthanequal',
    LESSER = 'lessthanequal',
    NULL = 'null',
    EMPTY = 'empty',
    NULLOREMPTY = 'nullorempty',
    EQUALS = 'exact'
}

export const DEFAULT_FORMATS: {[key: string]: string} = {
    DATE: 'yyyy-MM-dd',
    TIME: 'HH:mm:ss',
    TIMESTAMP: 'timestamp',
    DATETIME: 'yyyy-MM-ddTHH:mm:ss',
    LOCALDATETIME: 'yyyy-MM-ddTHH:mm:ss',
    DATETIME_ORACLE: 'yyyy-MM-dd HH:mm:ss',
    DATE_TIME: 'yyyy-MM-dd HH:mm:ss'
}
